module.exports = __webpack_public_path__ + "static/media/youtube-popup-sp.280e9ad7.jpg";